<template>
    <div class="width100">
        <b-modal id="modalInfo" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <div v-if="errors2.length" class="alert alert-danger text-center" role="alert">
                    <p v-for="(error, key) in errors2" :key="key">{{ error }}</p>
                </div>
                <div v-if="msgs2.length" class="alert alert-success text-center" role="alert">
                    <p v-for="(msg, key) in msgs2" :key="key">{{ msg }}</p>
                </div>
            </div>
        </b-modal>

        <button @click="getLocation">Get My Location</button>
        <p v-if="location">
            Latitude: {{ location.lat }} <br />
            Longitude: {{ location.lng }}
        </p>

        <h3 class="titreSolu text-center" v-if="niveau == 1" ref="other"> De quel type de panne s'agit il ? </h3>
        <div v-if="niveau == 1" class="row" style="overflow: scroll;height:250px;">
            <div v-for="(panne, keyPanne) in listPanneType" :key="keyPanne" class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                     @click="choixPanneType(keyPanne)">
                    {{panne}}
                </div>
            </div>
        </div>

        <div v-if="niveau>1" class="text-center">
            <br />
            <button class="btn btn-danger" block @click="returnNiveau()">Retour</button>
        </div>

    </div>
</template>

<script>

    export default {
        name: "Panne",
        props: ['token', 'site', 'user', 'racine', 'machine', 'userId','machineType','idModif','systemeClient'],
        data() {
            return {
                titrePanne:null,defautPanne:null, errors2:[], msgs2:{},niveau:1,panneKey:null,
                listPanneType :{1:'Crevaison',2:'Panne mécanique',3:'Frigo',4:'Accidents'},
                location: null,
            };
        },
        methods:
            {
                afficheDateFr(date)
                {
                    var today = new Date(date)
                    var month = today.getMonth() + 1
                    var day = today.getDate()
                    if (month < 10) {
                        month = "0" + month
                    }
                    if (day < 10) {
                        day = "0" + day
                    }

                    return day+ '/' + month+'/'+today.getFullYear()
                },
                choixPanneType(keyPanne)
                {
                    this.niveau = 2
                    this.panneKey = keyPanne
                    if(this.panneKey==1)
                    {
                        this.crevaison()
                    }
                },
                getLocation() {
                    console.log("1")
                    if ("geolocation" in navigator) {console.log("2")
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                this.location = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude
                                };
                            },
                            (error) => {
                                console.error("Error getting location:", error.message);
                            },
                            {
                                enableHighAccuracy: true, // High precision
                                timeout: 5000, // Wait max 5 seconds
                                maximumAge: 0 // No cache, always get fresh position
                            }
                        );
                    } else {
                        console.error("Geolocation is not supported by this browser.");
                    }
                },
                crevaison()
                {
                    var currentTime = new Date();
                    console.log(currentTime)
                    /*if(currentTime.getHours()>8 && currentTime.getHours()<18)
                    {

                    }
                    else
                    {

                    }*/
                },
                returnNiveau()
                {
                    if(this.niveau>1)
                    {
                        this.niveau--
                    }
                },

            },
        mounted() {

        }
    }
</script>

<style scoped>

</style>